exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".src-widgetTemplate-connectors-pm-Components-styles__previewContent___1Fg3K{margin-top:20px;text-align:center}\n", "", {"version":3,"sources":["/builds/GENEVA/wm/frontend/src/widgetTemplate/connectors/pm/Components/styles.scss"],"names":[],"mappings":"AAAA,4EACE,gBACA,iBAAkB,CACnB","file":"styles.scss","sourcesContent":[".previewContent {\n  margin-top: 20px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"previewContent": "src-widgetTemplate-connectors-pm-Components-styles__previewContent___1Fg3K"
};